import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DCEmptyStateComponent } from './empty-state.component';



@NgModule({
  declarations: [
    DCEmptyStateComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DCEmptyStateComponent
  ]
})
export class DCEmptyStateModule { }
